import ky from 'ky';

/**
 * API Configuration
 * The VITE_API_URL is set in wrangler.toml for production
 * and defaults to the staging URL for local development
 */
export const API_URL = import.meta.env.VITE_API_URL || 'https://kampusws.nexastaff.ai';

/**
 * Configured ky instance for API requests
 * - Automatically includes auth token from localStorage
 * - Sets JSON content type
 * - Configures timeout and retry behavior
 */
export const api = ky.create({
  prefixUrl: API_URL,
  timeout: 30000,
  retry: {
    limit: 2,
    methods: ['get'],
    statusCodes: [408, 429, 500, 502, 503, 504],
  },
  hooks: {
    beforeRequest: [
      (request) => {
        const token = localStorage.getItem('auth-token');
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        // Handle 401 unauthorized - clear auth and redirect to login
        if (response.status === 401) {
          localStorage.removeItem('auth-token');
          localStorage.removeItem('auth-user');
          if (window.location.pathname !== '/auth/login') {
            window.location.href = '/auth/login';
          }
        }
        return response;
      },
    ],
  },
});

/**
 * Type-safe API request helpers
 */
export const apiClient = {
  get: <T>(path: string, options?: Parameters<typeof api.get>[1]) =>
    api.get(path, options).json<T>(),

  post: <T>(path: string, data?: unknown, options?: Parameters<typeof api.post>[1]) =>
    api.post(path, { json: data, ...options }).json<T>(),

  put: <T>(path: string, data?: unknown, options?: Parameters<typeof api.put>[1]) =>
    api.put(path, { json: data, ...options }).json<T>(),

  patch: <T>(path: string, data?: unknown, options?: Parameters<typeof api.patch>[1]) =>
    api.patch(path, { json: data, ...options }).json<T>(),

  delete: <T>(path: string, options?: Parameters<typeof api.delete>[1]) =>
    api.delete(path, options).json<T>(),
};

export default apiClient;

